import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import 'react-toastify/dist/ReactToastify.css';
import { PageContextProvider } from './PageContext';

import { useAuth } from 'lib/context/auth';

import { isEnvDevelopment } from 'configs/api/enviroments';
import { ContactUsModalProvider, THEME_NAME } from 'lib/context';
import { VideoLimitProvider } from 'lib/context/videolimit/VideoLimitContext';
import { initFacebookSdk } from './pages/account/facebook/service/facebookInit';
import { MainRoutes } from './routes/main';
import { initChurnZero } from 'lib/hooks/initChurnZero';
import { isAdminSession } from 'lib/utils/auth';
import { createGlobalStyle } from 'styled-components/macro';
import { useGlobalAxiosErrorHandler } from 'lib/hooks/useGlobalAxiosErrorHandler';
import { PackageName } from 'lib/const/PackageAdditionalInfo';

export const DEFAULT_DOMAIN = 'www.covideo.com';

const GlobalStyle = createGlobalStyle<{ $isCdk?: boolean }>`
  * {
    font-family: ${({ $isCdk }) => ($isCdk ? "'Roboto', sans-serif" : "'Work Sans', sans-serif")};
  }
    button span {
    font-family: ${({ $isCdk }) => ($isCdk ? "'Roboto', sans-serif!important" : "'Work Sans', sans-serif")};
`;

export const App = () => {
  const { userData, whitelabel, themeName } = useAuth();
  const [cookies] = useCookies();
  useGlobalAxiosErrorHandler();

  useEffect(() => {
    if (!userData) return;

    const {
      trialAccount,
      customer: { freeTrial, packageId },
    } = userData;

    const hasFreeTrial = Boolean(Number(freeTrial));
    const isTrialAccount = Boolean(Number(trialAccount));
    const isFreePackage = parseInt(packageId) === PackageName.FREE;

    const shouldSkipInitChurnZero =
      isAdminSession() || isTrialAccount || hasFreeTrial || isFreePackage;

    if (shouldSkipInitChurnZero) return;

    initChurnZero(userData);
  }, [userData]);

  const isUpgrade = window.location.pathname.includes('/upgrade');
  const isSignUp = window.location.pathname.includes('/signup');
  const isResetPassword = window.location.pathname.includes(
    'verify-reset-password'
  );
  const packageDetailsExist = userData?.user?.packageDetails;

  const redirectParam =
    whitelabel?.name === 'Covideo'
      ? `?redirect=${window.location.toString()}`
      : '';
  if (!cookies.jwt && !isEnvDevelopment && !(isSignUp || isResetPassword)) {
    window.location.href = `https://${whitelabel?.domainV2 || DEFAULT_DOMAIN}/backoffice/incs/logout.php${redirectParam}`;
    return <></>;
  }

  // from AuthorizationContext
  if (!packageDetailsExist && !isSignUp && !isResetPassword) {
    window.location.href = `https://${whitelabel?.domainV2 || DEFAULT_DOMAIN}/backoffice/incs/logout.php${redirectParam}`;
    return <></>;
  }

  if (!userData.verified && !isUpgrade && !(isSignUp || isResetPassword)) {
    window.location.href = '/upgrade';
    return <></>;
  }

  initFacebookSdk();
  return (
    <>
      <link
        key={whitelabel?.name}
        type='text/css'
        rel='stylesheet'
        href={
          'https://' +
          whitelabel?.domainV2 +
          whitelabel?.contentPath +
          '/css/style.css'
        }
      />
      <PageContextProvider>
        <VideoLimitProvider>
          <ContactUsModalProvider>
            <BrowserRouter>
              <MainRoutes />
              <GlobalStyle $isCdk={themeName === THEME_NAME.CDK} />
            </BrowserRouter>
          </ContactUsModalProvider>
        </VideoLimitProvider>
      </PageContextProvider>
    </>
  );
};
